import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recuperar-password',
  templateUrl: './recuperar-password.component.html',
  styleUrls: ['../login/login.component.scss'] 
})
export class RecuperarPasswordComponent implements OnInit {
  loading:boolean = false;
  constructor() { }

  ngOnInit() {
  }

}
